import React from "react";
import { Box, Modal, Typography, Button, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

function BatchDetailsModal({ open, onClose, batch, records, loading, companyName }) {
  console.log('BATCH------>', batch)
  if (!batch) return null;

  console.log("this is current batch status",batch.status);

//   const getStatusDisplay = (code) => {
//   const map = {
//     "-2": "Open",
//     "-1": "Review",
//     "0": "Approved for Processing",
//     "5": "Rejected",
//     "3": "Completed",
//     "2": "Error",
//     "4": "Cancelled",
//   };
//   return map[code] || `Unknown (${code})`;
// };

const getStatusColor = (status) => {
  const colors = {
    Open: "#e2e3e5",
    Review: "#fff3cd",
    "Approved for Processing": "#d4edda",
    Rejected: "#f8d7da",
    Completed: "#d1ecf1",
    Error: "#f5c6cb",
    Cancelled: "#d6d8db",
  };
  return colors[status] || "#f8f9fa";
};

const getStatusTextColor = (status) => {
  const colors = {
    Open: "#383d41",
    Review: "#856404",
    "Approved for Processing": "#155724",
    Rejected: "#721c24",
    Completed: "#0c5460",
    Error: "#721c24",
    Cancelled: "#495057",
  };
  return colors[status] || "#333";
};

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          maxWidth: 1200,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box sx={{ p: 3, backgroundColor: "#5523D2", color: "white" }}>
          <Typography variant="h6">Batch Details - #{batch.id}</Typography>
          <Typography variant="body2">
            Company: <strong>{companyName}</strong> • File: {batch.fileName}
          </Typography>
          <Typography variant="body2">
            {records.length} Records &bull;  Scheduled for {batch.scheduledDateStr}
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, overflow: "auto", p: 3 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
              <CircularProgress />
            </Box>
          ) : records.length === 0 ? (
            <Typography textAlign="center" color="textSecondary" py={8}>
              No employee records found in this batch.
            </Typography>
          ) : (
            <TableContainer component={Paper} elevation={2}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell>
                      <strong>First Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Last Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Email</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Phone</strong>
                    </TableCell>
                    <TableCell align="right">
                      <strong>Amount</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Currency</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Status</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {records.map((rec, i) => (
                    <TableRow key={i} hover>
                      <TableCell>{decodeHtmlEntities(rec.firstname || "") || "—"}</TableCell>
                      <TableCell>{decodeHtmlEntities(rec.lastname || "") || "—"}</TableCell>
                      <TableCell>{rec.email || "—"}</TableCell>
                      <TableCell>{rec.phoneno || "—"}</TableCell>
                      <TableCell align="right">
                        {rec.amount || "0.00"}
                      </TableCell>
                      <TableCell>{rec.currency || "CAD"}</TableCell>
                      <TableCell>
                        {(() => {
                          const isError = !!rec.errormessage;
                          const status = isError ? "Error" : batch.status;
                          return (
                            <>
                              <Box
                                sx={{
                                  backgroundColor: getStatusColor(status),
                                  color: getStatusTextColor(status),
                                  padding: "4px 8px",
                                  borderRadius: "12px",
                                  fontSize: "0.8rem",
                                  display: "inline-block",
                                }}
                              >
                                {status}
                              </Box>
                              {isError && (
                                <Typography
                                  variant="body2"
                                  color="error"
                                  sx={{ mt: 1 }}
                                >
                                  {rec.errormessage}
                                </Typography>
                              )}
                            </>
                          );
                        })()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>

        {/* Footer */}
        <Box sx={{ p: 3, borderTop: "1px solid #eee", textAlign: "right" }}>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default BatchDetailsModal;
